import React from 'react';
import usePageContent from './usePageContent';
import PageHeroEditor from './PageHeroEditor';

const defaults = {
  hero: {
    title: 'About',
    highlight: 'PEA PNG',
    description:
      'We are the voice of public employees across Papua New Guinea, committed to advocating for fair treatment, professional development, and better working conditions.',
  },
};

const AboutHeroEditor = () => {
  const { loading, saving, sections, setSections, saveSection } = usePageContent({
    pageName: 'about',
    defaultsBySection: defaults,
  });

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageHeroEditor
        title={sections.hero.title}
        setTitle={(v) => setSections({ ...sections, hero: { ...sections.hero, title: v } })}
        highlight={sections.hero.highlight}
        setHighlight={(v) => setSections({ ...sections, hero: { ...sections.hero, highlight: v } })}
        description={sections.hero.description}
        setDescription={(v) => setSections({ ...sections, hero: { ...sections.hero, description: v } })}
        onSave={() => saveSection('hero')}
        saving={saving}
      />
    </div>
  );
};

export default AboutHeroEditor;
